import React, { FC } from "react";
import { LayoutProps } from "./Layout.props";
import Navbar from "@components/platform/Navbar/Navbar";

const PlatformLayout: FC<LayoutProps> = ({ children }) => {
	return (
		<div className="grid grid-rows-[max-content_1fr] min-h-screen">
			<Navbar />
			<main className="">{children}</main>
		</div>
	);
};

export default PlatformLayout;
